
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1200 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#9E3039","d":"M0 0h1200v600H0"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 240h1200v120H0"}})])
          )
        }
      }
    